import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id B8F96A7D-408E-4AB0-A137-E89DD4EC743E
 * name bank-circle
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bank-circle.svg
 * tags
 * - Banking 
 */
export const BankCircleIcon = createSvgIcon(<><path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M17 17H7V15H17V17M8 14V11H10V14H8M11 14V11H13V14H11M14 14V11H16V14H14M17 10H7V8.5L12 6L17 8.5V10Z" /></>, 'BankCircleIcon');
export default BankCircleIcon